import React from 'react'
import styled from '@emotion/styled'
import { string, bool } from 'prop-types'

// Import Components
import { Facebook } from '../svgs/Facebook'
import { LinkedIn } from '../svgs/LinkedIn'
import { Twitter } from '../svgs/Twitter'
import { Link } from '@jelly/ui'

// Styled Components via Emotion
const SocialBlockWrapper = styled.div`
	display: flex;
`
const LinkWrapper = styled(Link)`
	margin-right: 0.25rem;
	padding: 0 8px;
	:last-child {
		padding-left: 8px;
		padding-right: 0;
	}
`
const TextWrapper = styled.div`
	color: ${({ theme }) => theme.colors.darkGrey};
	padding-top: 5px;
`

ContentSocialBlock.propTypes = {
	canonical: string,
	color: string,
	customFacebookLink: string,
	customLinkedInLink: string,
	customTwitterLink: string,
	showShareThis: bool,
	title: string,
	variant: string,
}
/**
 * This is the Content Social Block
 * Social sharing button links for Facebook, ContentLinkedIn and ContentTwitter
 */
export function ContentSocialBlock({
	canonical,
	color,
	customFacebookLink,
	customLinkedInLink,
	customTwitterLink,
	showShareThis = false,
	title,
	variant = 'primary',
}) {
	// eslint-disable-next-line no-undef

	const SOCIAL_BUTTONS = [
		{
			socialIcon: Facebook,
			type: 'facebook',
			url:
				customFacebookLink ||
				`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(canonical)}&t=${encodeURIComponent(
					canonical
				)}`,
		},
		{
			socialIcon: LinkedIn,
			type: 'linkedIn',
			url:
				customLinkedInLink ||
				`http://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(canonical)}`,
		},
		{
			socialIcon: Twitter,
			type: 'twitter',
			url:
				customTwitterLink ||
				`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}:%20${encodeURIComponent(
					canonical
				)}`,
		},
	]

	return (
		<SocialBlockWrapper>
			{showShareThis && <TextWrapper>SHARE THIS</TextWrapper>}
			{SOCIAL_BUTTONS.map((socialButton, i) => (
				<LinkWrapper
					alt={`${socialButton.type} Sharing Link`}
					href={socialButton.url}
					key={i}
					target="_blank"
					rel="noopener noreferrer"
				>
					<socialButton.socialIcon color={color} height={34} variant={variant} width={34} />
				</LinkWrapper>
			))}
		</SocialBlockWrapper>
	)
}
